import React, { useMemo } from 'react';
import { Divider, Stack, Text } from 'rsuite';
import { CalculatedLicense } from 'src/types/tax';
import { convertNumberToCurrency } from '../../../common/utils';
import { TaxConfirmPeriodAccordion } from '../TaxConfirmPeriodAccordion';

export interface TaxConfirmPeriodSectionProps {
  period: CalculatedLicense;
}

/** Displays a single period with its label, licenses accordion, and total due. */
export const TaxConfirmPeriodSection = React.memo(
  ({ period }: TaxConfirmPeriodSectionProps) => {
    const totalDue = useMemo(() => {
      return convertNumberToCurrency(period.totalDueForPeriod ?? 0);
    }, [period.totalDueForPeriod]);

    return (
      <div style={{ marginBottom: '30px' }}>
        <Stack
          justifyContent="space-between"
          className="mb-16"
        >
          <Stack.Item>
            <Text
              className="text-bold"
              style={{ fontSize: '14px' }}
            >
              {period.label}
            </Text>
          </Stack.Item>
          <Stack.Item>
            <Text
              className="text-small"
              style={{ paddingRight: '50px' }}
            >
              Tax due
            </Text>
          </Stack.Item>
        </Stack>
        <TaxConfirmPeriodAccordion period={period} />
        <Stack
          justifyContent="space-between"
          className="pt-16"
        >
          <Text
            className="text-bold"
            style={{ fontSize: '14px' }}
          >
            Total due {period.label}
          </Text>
          <Text
            className="text-bold"
            style={{ fontSize: '16px', marginRight: '45px' }}
          >
            {totalDue}
          </Text>
        </Stack>
        <Divider className="bg-light-grey" />
      </div>
    );
  }
);

TaxConfirmPeriodSection.displayName = 'TaxConfirmPeriodSection';
